import {publicUrl} from 'lib/head';

import rows from './subjectCopy.csv';
import {normalizePagePath, pageCopyFromRows} from './pageCopy';
import type {PageCopy} from './pageCopy';

const pages = pageCopyFromRows(rows);
export function subjectPageCopy(pathname: string): PageCopy | undefined {
  return pages.get(normalizePagePath(pathname));
}

export function courseCopyStructuredData(
  name: string,
  description: string,
  url: string
): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name,
    description,
    url,
    provider: {'@type': 'Organization', name: 'Albert', url: 'https://www.albert.io'}
  };
}

export function withSubjectPageCopy(
  subjectName: string,
  existing: {title: string; metaDescription: string; canonicalPath: string}
) {
  const copy = subjectPageCopy(existing.canonicalPath);
  if (!copy) return existing;
  const description = copy.metaDescription ?? existing.metaDescription;
  return {
    ...existing,
    title: copy.title ?? existing.title,
    metaDescription: description,
    robots: 'index, follow',
    structuredData: courseCopyStructuredData(
      copy.name ?? subjectName,
      description,
      publicUrl(existing.canonicalPath)
    )
  };
}
